import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const VideoComp = ({ pc, h5, ...props }) => {
    const [videoSrc, setVideoSrc] = useState(pc || '');
    useEffect(() => {
        if (isH5HandleClient()) {
            setVideoSrc(h5 || pc || '');
        } else {
            setVideoSrc(pc || '');
        }
    }, [pc, h5]);

    return <video playsInline muted autoPlay loop src={videoSrc} {...props}></video>;
};

const VideoDialog: React.FC<{
    pc: string;
    h5: string;
    open: boolean;
    onClose: () => void;
}> = ({ pc, h5, open, onClose }) => {
    if (!open) return null;
    if (!pc && !h5) return null;

    if (pc.includes('www.youtube.com/embed')) {
        return (
            open && (
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    <EcoDialogVideo open={open} src={pc} callback={onClose} />
                </div>
            )
        );
    }
    if (pc.includes('www.youtube.com/watch?v=')) {
        const videoID = new URL(pc).searchParams.get('v');
        const href = `https://www.youtube.com/embed/${videoID}`;
        return (
            open && (
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    <EcoDialogVideo open={open} src={href} callback={onClose} />
                </div>
            )
        );
    }

    return createPortal(
        <div
            className="index-banner-swiper-item-video-dialog"
            onClick={(e) => {
                e.stopPropagation(); // 阻止事件冒泡
                e.preventDefault(); // 阻止默认行为（保险起见）
            }}
        >
            <div className="index-banner-swiper-item-video-dialog-close" onClick={onClose}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
                        fill="#3A3C3F"
                    />
                    <path
                        d="M16.3613 16.252C16.9471 15.6663 17.8967 15.6663 18.4824 16.252L24.0215 21.791L29.541 16.2715C30.1268 15.6857 31.0763 15.6858 31.6621 16.2715C32.2479 16.8573 32.2479 17.8068 31.6621 18.3926L26.1426 23.9121L31.6426 29.4121C32.2283 29.9979 32.2283 30.9474 31.6426 31.5332C31.0568 32.1189 30.1072 32.119 29.5215 31.5332L24.0215 26.0332L18.502 31.5527C17.9162 32.1384 16.9666 32.1385 16.3809 31.5527C15.7952 30.967 15.7952 30.0174 16.3809 29.4316L21.9004 23.9121L16.3613 18.373C15.7757 17.7873 15.7757 16.8377 16.3613 16.252Z"
                        fill="#CFD0D2"
                    />
                </svg>
            </div>
            <div className="index-banner-swiper-item-video-dialog-content">
                <VideoComp pc={pc} h5={h5} autoPlay={false} muted={false} loop={false} controls />
            </div>
        </div>,
        document.body,
    );
};

export default VideoDialog;
